import { render, staticRenderFns } from "./DetailedResults.vue?vue&type=template&id=5a5218bc&scoped=true"
import script from "./DetailedResults.vue?vue&type=script&lang=js"
export * from "./DetailedResults.vue?vue&type=script&lang=js"
import style0 from "./DetailedResults.vue?vue&type=style&index=0&id=5a5218bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5218bc",
  null
  
)

export default component.exports